/**
 * DASHBOARD ROUTE - CHATBOT IMÓVEIS®
 * =================================================================
 * Wrapper que adiciona DashboardLayout E AuthGuard para rotas protegidas
 *
 * CORREÇÃO FIREBASE AUTH - 11/11/2025:
 * - Usando AuthGuard original com Firebase
 * - Verificação única via onAuthStateChanged
 * - Sem manipulação manual de localStorage
 *
 * Data: 2025-11-11 (Restaurado para usar Firebase Auth)
 */

import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { AuthGuard } from '../auth/AuthGuard';

interface DashboardRouteProps {
  children: React.ReactNode;
}

/**
 * Wrapper que adiciona AMBOS DashboardLayout E AuthGuard
 * AuthGuard usa Firebase Auth para verificação segura
 */
export function DashboardRoute({ children }: DashboardRouteProps) {
  return (
    <AuthGuard>
      <DashboardLayout>{children}</DashboardLayout>
    </AuthGuard>
  );
}
